import {
	GET_ADDRESS_FROM_LAT_LNG_REQUEST,
	GET_ADDRESS_FROM_LAT_LNG_SUCCESS,
	GET_ADDRESS_FROM_LAT_LNG_ERROR,
	RESET_ADDRESS_FROM_LAT_LNG_RESPONSE
} from 'actions/addressFromLatLngActions';

import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

const defaultState = {
	asyncStatus: INIT
};

export default function addressLocationReducer(state = defaultState, action) {
	switch (action.type) {
		case GET_ADDRESS_FROM_LAT_LNG_REQUEST:
			return { asyncStatus: LOADING };
		case GET_ADDRESS_FROM_LAT_LNG_SUCCESS:
			return { asyncStatus: SUCCESS, data: action.data };
		case GET_ADDRESS_FROM_LAT_LNG_ERROR:
			return { asyncStatus: ERROR, error: action.error };
		case RESET_ADDRESS_FROM_LAT_LNG_RESPONSE:
			return defaultState;
		default:
			return state;
	}
}
